import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyBe2-mS7UPLKg2Z8hmFq-UsTzb45gO9CvQ",
  authDomain: "gpschoolbus.firebaseapp.com",
  projectId: "gpschoolbus",
  storageBucket: "gpschoolbus.firebasestorage.app",
  messagingSenderId: "273852717856",
  appId: "1:273852717856:web:c38bd8f7a6919d41b85545",
  measurementId: "G-BTEM0TKZG0"
};

// AJOUT DE "export" ICI
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// CORRECTION DE LA RÉGION : 'us-central1' pour correspondre au déploiement
export const functions = getFunctions(app, "us-central1");